var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3553 1.82725C10.3553 1.82725 11.3266 1.4485 11.2453 2.36825C11.2186 2.747 10.9758 4.07275 10.7868 5.5065L10.1393 9.754C10.1393 9.754 10.0853 10.3763 9.59957 10.4845C9.11407 10.5925 8.38557 10.1058 8.25057 9.9975C8.14257 9.91625 6.22707 8.69875 5.55257 8.10375C5.36357 7.94125 5.14757 7.61675 5.57957 7.238L8.41232 4.5325C8.73607 4.208 9.05982 3.4505 7.71082 4.37025L3.93332 6.94025C3.93332 6.94025 3.50157 7.211 2.69232 6.9675L0.938324 6.42625C0.938324 6.42625 0.290823 6.0205 1.39707 5.61475C4.09532 4.34325 7.41407 3.04475 10.3548 1.82725H10.3553Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram2);
export default __webpack_public_path__ + "static/media/telegram2.51ce8d1b718003aa6f59680a2a0e130b.svg";
export { ForwardRef as ReactComponent };